import React, { useEffect, useState } from "react";

const GiftAid = ({
	register,
	watch,
	setValue,
	error,
	required = false,
	className = "",
	id,
	formData,
	field,
}) => {
	const donationAmount = formData.donation_frequency_and_amount.amount;
	const giftAidAmount = (parseFloat(donationAmount) * 0.25).toFixed(2);
	const giftAidSelected = !!watch?.(id);

	// reset the value when the field is hidden/unmounted
	useEffect(() => {
		return () => {
			// Field is being hidden/unmounted → reset it
			setValue?.(id, false, {
				shouldValidate: false,
				shouldDirty: false,
				shouldTouch: false,
			});
		};
	}, [id, setValue]);

	const totalWithGiftAid = Number(
		parseFloat(donationAmount) + parseFloat(giftAidAmount)
	).toFixed(2);

	const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);
	return (
		<div className={`gift-aid-block ${className}`}>
			<div className="gift-aid-header">
				<img src={field.icon} alt="Gift Aid" />
				<p className="gift-aid-question">Are you a UK tax payer?</p>
				<p className="gift-aid-boost">
					Boost your donation by <strong>£{giftAidAmount}</strong> with Gift
					Aid, at no extra cost to you.
				</p>
				<div className="gift-aid-checkbox-label">
					<input
						type="checkbox"
						id={id}
						className={`gift-aid-checkbox-input${
							error ? " gift-aid-input--error" : ""
						}`}
						checked={giftAidSelected}
						readOnly
						tabIndex={-1}
						aria-hidden="true"
						style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}
						{...register(id, {
							required: required ? "Please make a selection" : false,
						})}
					/>
					<button
						type="button"
						className={`gift-aid-button${
							giftAidSelected ? " gift-aid-button--selected" : ""
						}${error ? " gift-aid-input--error" : ""}`}
						aria-pressed={giftAidSelected}
						onClick={() => {
							if (!setValue) return;
							setValue(id, !giftAidSelected, {
								shouldValidate: true,
								shouldDirty: true,
							});
						}}
					>
						{giftAidSelected ? (
							<>
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="20" height="20" rx="10" fill="#00C34B"/>
								<path d="M7 10L9 12L13 8" stroke="white" strokeWidth="1.5" strokeLinecap="square"/>
							</svg>
							Claimed
							</>
							) : (
							<>
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.75" y="0.75" width="18.5" height="18.5" rx="10" stroke="currentColor" strokeWidth="1.5" bgcolor="#FFFFFF" />
							</svg>
							Claim Gift Aid
							</>
						)}
					</button>
				</div>


				
				<button
				type="button"
				className="gift-aid-more-details"
				aria-expanded={moreDetailsOpen}
				aria-controls={`${id}-gift-aid-more-details`}
				onClick={() => setMoreDetailsOpen((v) => !v)}
				>
					More details
					<svg 
					style={{
						display: "inline-block",
						transform: moreDetailsOpen ? "rotate(180deg)" : "rotate(0deg)",
						transition: "transform 200ms ease",
					}}				
					width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="16" height="16" fill="white" fillOpacity="0.01"/>
						<path fillRule="evenodd" clipRule="evenodd" d="M14.4517 4.15132L7.99991 10.603L1.5481 4.15132C1.34633 3.94956 1.01959 3.94956 0.817828 4.15132C0.616063 4.35309 0.616063 4.67983 0.817828 4.88159L7.63478 11.6984C7.73551 11.7993 7.86771 11.8497 7.99991 11.8497C8.13196 11.8497 8.26416 11.7993 8.36505 11.6984L15.182 4.88159C15.3838 4.67983 15.3838 4.35309 15.182 4.15132C14.9802 3.94956 14.6535 3.94956 14.4517 4.15132Z" fill="#00288C"/>
					</svg>
				</button>
				<div
				id={`${id}-gift-aid-more-details`}
				className={`gift-aid-more-details-content${moreDetailsOpen ? " is-open" : ""}`}
				>
					<div dangerouslySetInnerHTML={{ __html: field.content }} />
					<p>
						You can update or cancel a Gift Aid declaration at any time by{" "}
						<a href="/contact/" target="_blank">
							contacting us
						</a>
						. You can find out more about Gift Aid and its benefits to charities{" "}
						<a
							href="/what-is-gift-aid-and-how-do-charities-benefit/"
							target="_blank"
						>
							here
						</a>
						.
					</p>
				</div>
			</div>
			<div className="gift-aid-summary">
				<p className="gift-aid-summary-title">
					With Gift Aid, your donation of £{donationAmount} would be worth
				</p>
				<p className="gift-aid-summary-note">
					Add £{giftAidAmount} to your donation at no cost to you.
				</p>
				<div className="gift-aid-summary-amount">£{totalWithGiftAid}</div>
			</div>
		</div>
	);
};

export default GiftAid;
